// Wedding date and related constants
export const WEDDING_DATE_START = new Date('2026-03-20T15:00:00-06:00'); // March 20, 2026, 4 PM Mexico City time
export const WEDDING_DATE_END = new Date('2026-03-22T13:00:00-06:00'); // March 22, 2026

// Display formats
export const WEDDING_DATE_DISPLAY = '21 • MARZO • 2026';
export const WEDDING_DATE_SIMPLE = '21 Marzo 2026';

export const WEDDING_DESCRIPTION = '¡Aparta la fecha! Estamos ansiosos de poder compartir este evento con ustedes.'

// Wedding details
export const WEDDING_TITLE = "Boda de Eli y Lalo";
export const WEDDING_LOCATION = 'TRES MARÍAS, MORELOS';
export const WEDDING_VENUE = 'Corazón de Montaña (Feudo de Caza)';

// Countdown labels
export const COUNTDOWN_LABELS = {
  days: 'DÍAS',
  hours: 'HORAS', 
  minutes: 'MINUTOS',
  seconds: 'SEGUNDOS'
} as const;

export const MENSAJE_GENERICO_SINGULAR = 'Nos ilusiona profundamente poder compartir contigo este día tan importante. No podríamos imaginar este día sin las personas que más estimamos. Queremos reír, llorar, brindar y celebrar juntos el inicio de esta nueva etapa. Tu compañía hará que la celebración cobre vida y se convierta en un recuerdo invaluable.\nCon mucho cariño, te esperamos.'

export const MENSAJE_GENERICO_PLURAL = 'Nos ilusiona profundamente poder compartir con ustedes este día tan importante. No podríamos imaginar este día sin las personas que más estimamos. Queremos reír, llorar, brindar y celebrar juntos el inicio de esta nueva etapa. Su compañía hará que la celebración cobre vida y se convierta en un recuerdo invaluable.\nCon mucho cariño, los esperamos.'